<template>        
  <div id="app-nav">
    <div class="nv-search">
      <i class="fa fa-search nv-search-icon"></i>
      <input
        ref="search"
        v-model="query"
        type="text"
        class="nv-search-input"
        placeholder="Search menu"
        aria-label="Search menu"
        @keydown.enter.prevent="openFirstMatch"
        @keydown.esc="query = ''">
      <button v-if="query" type="button" class="nv-search-clear" aria-label="Clear search" @click="query = ''"><i class="fa fa-times"></i></button>
    </div>
    <p v-if="query && !matchCount" class="nv-search-empty">No menu items match "{{ query }}"</p>
    <ul class="sidebar-menu">
      <li v-if="adminUser" class="header">Overview</li>
      <li v-if="adminUser" :class="{ 'active': $route.path === '/summary'}">
        <router-link to="/">
          <i class="fa fa-th-large"></i> <span>Dashboard</span>
        </router-link>
      </li>
      <li v-if="adminUser" class="header">Engagement</li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/nudge-console/dashboard' || $route.path === '/nudge-console/create-campaign' || $route.path === '/nudge-console/analytics'}">
        <a href="#">
          <i class="fa fa-bell"></i> <span>Nudge Console</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/nudge-console/dashboard"><i class="fa fa-dashboard"></i> Dashboard</router-link></li>
          <li><router-link to="/nudge-console/create-campaign"><i class="fa fa-plus"></i> Create Campaign</router-link></li>
          <li><router-link to="/nudge-console/analytics"><i class="fa fa-bar-chart"></i> Analytics</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path.indexOf('/nudge-template') === 0 || $route.path === '/nudge-template-addOrUpdate' }">
        <a href="#">
          <i class="fa fa-paper-plane"></i> <span>Nudge Template Manager</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/nudge-template/view"><i class="fa fa-list"></i> View Templates</router-link></li>
          <li><router-link to="/nudge-template/create"><i class="fa fa-plus"></i> <span> Add Template</span></router-link></li>
          <li><router-link to="/nudge-template/ai-create"><i class="fa fa-magic"></i> <span> AI Nudge Creation</span></router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/audience-builder/view' || $route.path === '/audience-builder/create' || $route.path === '/audience-builder/upload' || $route.path === '/audience-builder/manage-folder'  || $route.path === '/audience-builder/update' || $route.path === '/audience-builder/ai-generate'}">
        <a href="#">
          <i class="fa fa-users"></i> <span>Audience Builder</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/audience-builder/view"><i class="fa fa-list"></i> View Queries</router-link></li>
          <li><router-link to="/audience-builder/create"><i class="fa fa-plus"></i> <span> Create Audience</span></router-link></li>
          <li><router-link to="/audience-builder/upload"><i class="fa fa-plus"></i> <span> Upload Audience</span></router-link></li>
          <li><router-link to="/audience-builder/manage-folder"><i class="fa fa-plus"></i> <span>Manage Folders</span></router-link></li>
          <li><router-link to="/audience-builder/ai-generate"><i class="fa fa-magic"></i> <span> Generate AI Audience</span></router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/opportunity-list' || $route.path === '/opportunity' || $route.path === '/opportunity/:opportunityId?' || $route.path === '/opportunity/:opportunityId?/:action?'}">
        <a href="#">
          <i class="fa fa-bullseye"></i> <span>Database Marketing</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/opportunity-list"><i class="fa fa-list"></i> View</router-link></li>
          <li><router-link to="/dbm-reports"><i class="fa fa-file-text"></i> Reports</router-link></li>
          <li><router-link to="/opportunity"><i class="fa fa-plus"></i> Create</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/reengagement-manager/view' || $route.path === '/reengagement-manager/create'  || $route.path === '/reengagement-manager/:campaignId?'}">
        <a href="#">
          <i class="fa fa-refresh"></i> <span>Reengagement Manager</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/reengagement-manager/view"><i class="fa fa-list"></i> View </router-link></li>
          <li><router-link to="/reengagement-manager/create"><i class="fa fa-plus"></i> Create</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="header">Content</li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/conversation/create' || $route.path === '/conversation/view' || $route.path === '/conversation/update'}">
        <a href="#">
          <i class="fa fa-comments-o"></i> <span>Conversations</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/conversation/view"><i class="fa fa-list"></i> View</router-link></li>
          <li><router-link to="/conversation/create"><i class="fa fa-plus"></i> Create</router-link></li>
          <li><router-link to="/nlp_topic_list"><i class="fa fa-list"></i> Topic-Conversation Mapping</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/user-journey/create' || $route.path === '/user-journey/view' || $route.path === '/user-journey/update'}">
        <a href="#">
          <i class="fa fa-sitemap"></i> <span>User Journey</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/user-journey/view"><i class="fa fa-list"></i> View </router-link></li>
          <li><router-link to="/user-journey/create"><i class="fa fa-plus"></i> Create </router-link></li>
          <li><a href="#" @click.prevent="openCreateNewJourney"><i class="fa fa-plus"></i> AI Journey Builder </a></li>
          <li><a href="#" @click.prevent="openChatSimulator"><i class="fa fa-comments"></i> Chat Simulator </a></li>
          <li><router-link to="/scout_jor_list"><i class="fa fa-list"></i> Scout-JOR Mapping</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/entry-points/create' }">
        <a href="#">
          <i class="fa fa-map-marker"></i> <span>Entry Points</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/entry-points/create"><i class="fa fa-plus"></i> Create new</router-link></li>
          <li><router-link to="/entry-points/create?tab=journey-defaults"><i class="fa fa-sliders"></i> Journey defaults</router-link></li>
          <li><router-link to="/entry-points/create?tab=all-entry-points"><i class="fa fa-list"></i> View all</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/prompt-management/view' || $route.path === '/prompt-management/create' || $route.path === '/prompt-management/update'}">
        <a href="#">
          <i class="fa fa-terminal"></i> <span>Prompt Management</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/prompt-management/view"><i class="fa fa-list"></i> View </router-link></li>
          <li><router-link to="/prompt-management/create"><i class="fa fa-plus"></i> Create</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/messages-dashboard'}">
        <a href="#">
          <i class="fa fa-mobile"></i> <span>App Messages</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/messages-dashboard"><i class="fa fa-list"></i> View</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/keywords_list'  || $route.path === '/NewKeywordsDetails'}">
        <a href="#">
          <i class="fa fa-keyboard-o"></i> <span>Keyword Management</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/keywords_list"><i class="fa fa-list"></i> View</router-link></li>
          <li><router-link to="/NewKeywordsDetails"><i class="fa fa-plus"></i> Create</router-link></li>
          <li><router-link to="/phrases_list"><i class="fa fa-list"></i> Phrase View</router-link></li>
          <li><router-link to="/PhrasesDetails"><i class="fa fa-plus"></i> Create Phrase</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser || apaUser" class="header">Data &amp; Resources</li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/virtual-resources-addOrUpdate' || $route.path === '/resources-virtual' || $route.path === '/locate-resources'}">
        <a href="#">
          <i class="fa fa-book"></i> <span>Resources</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/resources-virtual"><i class="fa fa-list"></i> View Virtual Resources</router-link></li>
          <li><router-link to="/virtual-resources-addOrUpdate"><i class="fa fa-plus"></i> Add Virtual Resource</router-link></li>
          <li><router-link to="/bulk-upload-physical-resources"><i class="fa fa-plus"></i> Bulk Upload Physical Resources</router-link></li>
          <li><router-link to="/locate-resources"><i class="fa fa-map-marker"></i> Locate Resources</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/offering-manager/view' || $route.path === '/offering-manager/create' || $route.path === '/offering-manager/update'}">
        <a href="#">
          <i class="fa fa-cubes"></i> <span>Offering Management</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/offering-manager/view"><i class="fa fa-list"></i> View </router-link></li>
          <li><router-link to="/offering-manager/create"><i class="fa fa-plus"></i> Create</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview"  :class="{ 'active': $route.path === '/customer-list' || $route.path === '/customer-addOrUpdate'}">
        <a href="#">
          <i class="fa fa-user"></i> <span>Customer Management</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/customer-list"><i class="fa fa-list"></i> View</router-link></li>
          <li><router-link to="/customer-addOrUpdate"><i class="fa fa-plus"></i> Create</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/link-list' || $route.path === '/link-addOrUpdate'}">
        <a href="#">
          <i class="fa fa-link"></i> <span>Link Management</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/link-list"><i class="fa fa-list"></i> View</router-link></li>
          <li><router-link to="/link-addOrUpdate"><i class="fa fa-plus"></i> Create</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/media-management/view' || $route.path === '/media-management/upload' || $route.path === '/media-management/upload'}">
        <a href="#">
          <i class="fa fa-picture-o"></i> <span>Media Management</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/media-management/view"><i class="fa fa-list"></i> View </router-link></li>
          <li><router-link to="/media-management/upload"><i class="fa fa-plus"></i> Upload</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser" class="treeview" :class="{ 'active': $route.path === '/user-upload/create' }">
        <a href="#">
          <i class="fa fa-user-plus"></i> <span>User Upload</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/user-upload/create"><i class="fa fa-plus"></i> Create</router-link></li>
        </ul>
      </li>
      <li v-if="apaUser || adminUser" class="treeview" :class="{ 'active': $route.path === '/file-upload/create' }">
        <a href="#">
          <i class="fa fa-folder-open-o"></i> <span>File System</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/file-upload/create"><i class="fa fa-plus"></i> Files</router-link></li>
        </ul>
      </li>
      <li v-if="adminUser || auditUser" class="header">Quality</li>
      <li v-if="auditUser || adminUser" class="treeview" :class="{ 'active': $route.path.includes('/auditing/') }">
        <a href="#">
          <i class="fa fa-pencil-square-o"></i> <span>Auditing Tool</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/auditing/symptoms"><i class="fa fa-heartbeat"></i> Symptoms </router-link></li>
          <li><router-link to="/auditing/medications"><i class="fa fa-medkit"></i> Medications </router-link></li>
          <li><router-link to="/auditing/chat-intent"><i class="fa fa-weixin"></i> Chat Intent </router-link></li>
        </ul>
      </li>
    </ul>
    <div class="nv-user">
      <span class="nv-user-avatar">{{ initials }}</span>
      <div class="nv-user-info">
        <span class="nv-user-name">{{ username }}</span>
        <span class="nv-user-role">{{ roleLabel }}</span>
      </div>
      <a href="#" class="nv-user-logout" title="Log out" @click.prevent="exitApp"><i class="fa fa-sign-out"></i></a>
    </div>
  </div>
</template>

<script>
import { logout } from '../../utils/auth'
import jwtDecode from 'jwt-decode'

export default {
  name: 'app-nav',
  mounted () {
    const token = localStorage.getItem(process.env.CLIENT_SECRET) // get token from local storage
    const decoded = jwtDecode(token) // decode token]

    const username = localStorage.getItem('username')
    if (username) {
      this.username = username.replace(/\./g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase() })
    }

    const role = decoded && decoded.userRoles && decoded.userRoles[0] // extract roles from decoded token
    this.auditUser = role === 'audit_user'
    this.apaUser = role === 'apa_user'
    this.adminUser = role !== 'audit_user' && role !== 'apa_user'
  },
  data () {
    return {
      auditUser: false,
      apaUser: false,
      adminUser: false,
      username: 'Guest',
      query: '',
      matchCount: 0,
      firstMatch: null
    }
  },
  watch: {
    query () {
      this.filterMenu()
    }
  },
  computed: {
    initials () {
      return this.username.split(' ').filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('')
    },
    roleLabel () {
      if (this.auditUser) return 'Auditor'
      if (this.apaUser) return 'APA user'
      return 'Admin'
    }
  },
  methods: {
    exitApp () {
      logout()
    },
    openChatSimulator () {
      const routeData = this.$router.resolve({ path: '/user-journey/chat-simulator' })
      window.open(routeData.href, '_blank')
    },
    // Filters the (static) menu markup in place. Uses inline display so Vue's own class bindings
    // and AdminLTE's open/closed submenu state are left alone, and restored when the box is cleared.
    filterMenu () {
      const q = this.query.trim().toLowerCase()
      const items = Array.from(this.$el.querySelectorAll('.sidebar-menu > li'))
      let count = 0
      let first = null
      let header = null
      let headerHasMatch = false
      const closeHeader = () => {
        if (header) header.style.display = q && !headerHasMatch ? 'none' : ''
      }
      items.forEach(li => {
        if (li.classList.contains('header')) {
          closeHeader()
          header = li
          headerHasMatch = false
          return
        }
        const link = li.querySelector(':scope > a')
        const sub = li.querySelector(':scope > .treeview-menu')
        const label = (link ? link.textContent : '').trim().toLowerCase()
        if (sub && !('nvDisplay' in sub.dataset)) sub.dataset.nvDisplay = sub.style.display
        if (!q) {
          li.style.display = ''
          if (sub) {
            sub.style.display = sub.dataset.nvDisplay
            delete sub.dataset.nvDisplay
            Array.from(sub.children).forEach(c => { c.style.display = '' })
          }
          return
        }
        const parentMatch = label.indexOf(q) !== -1
        let childMatch = false
        if (sub) {
          Array.from(sub.children).forEach(child => {
            const match = parentMatch || child.textContent.toLowerCase().indexOf(q) !== -1
            child.style.display = match ? '' : 'none'
            if (match) {
              childMatch = true
              if (!first) first = child.querySelector('a')
            }
          })
        } else if (parentMatch && !first) {
          first = link
        }
        const show = parentMatch || childMatch
        li.style.display = show ? '' : 'none'
        if (sub) sub.style.display = show ? 'block' : 'none'
        if (show) {
          count++
          headerHasMatch = true
        }
      })
      closeHeader()
      this.matchCount = count
      this.firstMatch = first
    },
    openFirstMatch () {
      if (!this.firstMatch) return
      this.firstMatch.click()
      this.query = ''
    },
    openCreateNewJourney () {
      const routeData = this.$router.resolve({ path: '/user-journey/create-new' })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style>
/* Sidebar layout. Unscoped: AdminLTE toggles sidebar-collapse on <body> and owns the treeview markup.
   Colors follow nivi.io's sidebar tokens: white surface, navy text, teal tint for the current item. */
#app-nav {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.skin-blue .sidebar-menu {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 12px 12px 16px;
}
.skin-blue .sidebar-menu:hover {
  overflow-x: hidden;
  overflow-y: auto;
}
.skin-blue .sidebar-menu::-webkit-scrollbar { width: 6px; }
.skin-blue .sidebar-menu::-webkit-scrollbar-thumb { background: rgba(30, 58, 95, 0.15); border: none; }

.skin-blue .sidebar-menu > li.header {
  background: transparent;
  color: #8896A5;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 18px 12px 8px;
}
.skin-blue .sidebar-menu > li.header:first-child { padding-top: 6px; }

.skin-blue .sidebar-menu > li { margin-bottom: 2px; }
.skin-blue .sidebar-menu > li > a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-left: none;
  border-radius: 8px;
  color: #2D3748;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.skin-blue .sidebar-menu > li > a > .fa:first-child {
  width: 18px;
  text-align: center;
  font-size: 15px;
  color: #8896A5;
  transition: color 0.15s ease;
}
.skin-blue .sidebar-menu > li > a > span:not(.pull-right-container) {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.skin-blue .sidebar-menu > li > a > .pull-right-container { right: 12px; }
.skin-blue .sidebar-menu > li.treeview > a { padding-right: 30px; }
.skin-blue .sidebar-menu > li > a > .pull-right-container > .fa { color: #B4BFCB; }

.skin-blue .sidebar-menu > li:hover > a {
  background: rgba(30, 58, 95, 0.06);
  color: #1E3A5F;
}
.skin-blue .sidebar-menu > li.active > a,
.skin-blue .sidebar-menu > li.menu-open > a {
  background: transparent;
  color: #1E3A5F;
}
.skin-blue .sidebar-menu > li:hover > a > .fa:first-child,
.skin-blue .sidebar-menu > li.active > a > .fa:first-child,
.skin-blue .sidebar-menu > li.menu-open > a > .fa:first-child {
  color: #0D9488;
}

/* Sub-items hang off a thin rail */
.skin-blue .sidebar-menu > li > .treeview-menu {
  background: transparent;
  margin: 2px 0 6px 20px;
  padding: 0 0 0 10px;
  border-left: 1px solid rgba(30, 58, 95, 0.12);
}
.skin-blue .treeview-menu > li > a {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  white-space: normal; /* AdminLTE sets nowrap on the menu; long labels like "Topic-Conversation Mapping" spill out */
  line-height: 1.35;
  padding: 7px 10px;
  border-radius: 6px;
  color: #5C6E8A;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.skin-blue .treeview-menu > li > a > .fa { flex-shrink: 0; width: 14px; margin-top: 3px; font-size: 12px; text-align: center; opacity: 0.7; }
.skin-blue .treeview-menu > li > a:hover {
  background: rgba(30, 58, 95, 0.06);
  color: #1E3A5F;
}
.skin-blue .treeview-menu > li > a.router-link-exact-active {
  background: rgba(13, 148, 136, 0.13);
  color: #0B7C72;
  font-weight: 600;
}
.skin-blue .treeview-menu > li > a.router-link-exact-active > .fa { opacity: 1; }

/* Plain links (no submenu) get the teal tint when they're the current page */
.skin-blue .sidebar-menu > li:not(.treeview) > a.router-link-exact-active {
  background: rgba(13, 148, 136, 0.13);
  color: #0B7C72;
}
.skin-blue .sidebar-menu > li:not(.treeview) > a.router-link-exact-active > .fa:first-child { color: #0D9488; }

/* User card pinned to the bottom */
.nv-user {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 12px 12px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(30, 58, 95, 0.08);
}
.nv-user-avatar {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1E3A5F 0%, #000e0c 100%);
  color: #FFFFFF;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nv-user-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  text-align: left;
}
.nv-user-name {
  color: #1E3A5F;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nv-user-role { color: #5C6E8A; font-size: 12px; }
.skin-blue .sidebar .nv-user-logout {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8896A5;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.skin-blue .sidebar .nv-user-logout:hover {
  background: #FCE8EB;
  color: #E05263;
}

/* Menu search */
.nv-search {
  position: relative;
  margin: 12px 12px 0;
  flex-shrink: 0;
}
.nv-search-input {
  width: 100%;
  height: 36px;
  padding: 0 32px 0 34px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.75);
  color: #2D3748;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}
.nv-search-input::placeholder { color: #8896A5; }
.nv-search-input:focus {
  background: #FFFFFF;
  border-color: #0D9488;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.18);
}
.nv-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #8896A5;
  font-size: 13px;
  pointer-events: none;
}
.nv-search-clear {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #8896A5;
  cursor: pointer;
}
.nv-search-clear:hover { background: #E2E8F0; color: #1E3A5F; }
.nv-search-empty {
  margin: 12px 24px 0;
  color: #8896A5;
  font-size: 13px;
  white-space: normal;
}

/* Collapsed to icons (AdminLTE sidebar-mini) */
@media (min-width: 768px) {
  .sidebar-mini.sidebar-collapse .main-sidebar .sidebar,
  .sidebar-mini.sidebar-collapse .sidebar-menu,
  .sidebar-mini.sidebar-collapse .sidebar-menu:hover {
    overflow: visible;
  }
  .sidebar-mini.sidebar-collapse .sidebar-menu { padding: 12px 6px; }
  .sidebar-mini.sidebar-collapse .sidebar-menu > li > a,
  .sidebar-mini.sidebar-collapse .sidebar-menu > li.treeview > a {
    justify-content: center;
    padding: 10px 0;
  }
  /* AdminLTE puts the chevron back in flow on hover, which shoves the centered icon out of view */
  .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span.pull-right-container,
  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span.pull-right-container {
    display: none !important;
  }
  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right) {
    top: 0;
    left: 100%; /* flush with the item: any gap drops :hover before the pointer reaches the flyout */
    margin-left: 0;
    padding: 9px 14px;
    background: #FFFFFF;
    color: #1E3A5F;
    border: 1px solid #E2E8F0;
    border-radius: 0 8px 8px 0;
  }
  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {
    left: 100%;
    top: 38px;
    width: max-content;
    min-width: 180px;
    max-width: 260px;
    margin: 0;
    padding: 6px;
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 8px 30px -4px rgba(29, 40, 58, 0.12);
  }
  .sidebar-mini.sidebar-collapse .nv-user {
    flex-direction: column;
    margin: 0 4px 10px;
    padding: 8px 0;
    background: transparent;
    border: none;
  }
  .sidebar-mini.sidebar-collapse .nv-user-info { display: none; }
  .sidebar-mini.sidebar-collapse .nv-search,
  .sidebar-mini.sidebar-collapse .nv-search-empty { display: none; }
}
</style>



// WEBPACK FOOTER //
// Nav.vue?20111e0c